/**
 * @file network_api.js
 * @desc This module contains network API definition.
 * @author Slaus Blinnikov <blinnikov.slaus.ksi@gmail.com>
 * @version 1.0.dev
 * @copyright 2016 (c) KSI Corporation
 * */

import { request, OPERATION_ID, init, cookies, cookiesSettings } from "./request";
import Stream from "../frp/stream";

/**
* Enum for game stage
* @readonly
* @enum {Number}
* @memberOf Server
* */
export const SERVER_STAGE_TYPE = {
    UNDEFINED : 0,
    REGULAR : 1,
    FINAL : 2,
    FREEGAME : 3, FREESPIN : 3,
    BONUS_1 : 4,
    BONUS_2 : 5,
    BONUS_3 : 6,
    /** Состояние окончания фригеймов или бонуса, где отображаются барабаны и игрок должен, обычно, решить что ему делать дальше: войти в риск или забрать выигрыш.*/
    FINISH : 7,
    JACKPOT : 8,
    /** Отображается как рулетка. Становится известно что будет дальше в сценарии: джекпот (следующим stage'ом) или бонус (когда-то потом в сценарии). После первого такого состояния следует второе такое же, где уже отображается выигрыш (в первом его нет в данных).*/
    PRECURSOR : 9,
    RISK_MAIN : 10,
    RISK_RESULT : 11,
    RISK_RESULT_RED : 12,
    RISK_RESULT_BLACK : 13,
    PROGRESSIVE_JACKPOT : 30,
};
export const TYPE = SERVER_STAGE_TYPE;

/**
* Возможные варианты логина на сервер. Для нас имеет смысл только WEB - остальные просто берутся из лобби как есть.
* @readonly
* @enum {Number}
* @memberOf Server
*/
export const SERVER_IDENTITY_TYPE = {
    /** { "terminal_id": -1265348240 } */
    TERMINAL : 1,
    /** { "terminal_id": -1265348240, "card_id": "01ad54fe" } */
    RFID : 2,
    /** { "login": "user1" } */
    WEB : 3
};

/**
* Возможные действия выбора игрока в риске. Позже рассмотрим архитектуру 4(5)-карточного риска.
* @type {{RED: number, BLACK: number}}
* @memberOf Server
*/
export const RISK_CHOICE =
{
    UNDEFINED : 0,
    RED : 1,
    BLACK : 2
};

/** Возможные типы рисков.*/
export const RISK_TYPE = 
{
    UNDEFINED : 0,
    RED_BLACK : 1,
    FIVE_CARDS : 2,
    RED_BLACK_SRS : 3
};

//оказывается не раотает если определять только как this - чтобы работало как и раньше через Server.GAME_TYPE:
/** Enum for possible game types server may station on. */
export const GAME_TYPE = {
    UNDEFINED_GAME_TYPE : 0,

    /** Основная игра (вращающийся барабан). Отсюда переходить в: риск, фригеймы, взять выигрыш или просто "объявить" об окончании спина (takeWin()). */
    REGULAR : 1,

    /** Фриспин. Дальше либо: фриспин, takeWin(), risk. */
    FREEGAME : 2,

    /** Процесс выбора карты в риске.*/
    RISK : 3,

    /** Какой-то обычный бонус.*/
    BONUS_1 : 5,
    /** Какой-то ещё бонус.*/
    BONUS_2 : 6,
    /** Супер-бонус, наверно.*/
    BONUS_3 : 7,
    
    /** Просто денежный выигрыш независящий ни от чего - доступен после состояния REGULAR.*/
    JACKPOT : 8,
    
    /** Отображается как рулетка. Становится известно что будет дальше в сценарии: джекпот (следующим stage'ом) или бонус (когда-то потом в сценарии).*/
    PRECURSOR : 9,
    /** Рулетка только что показалась. Нужно нажать на старт чтобы перейти на следующее такое же состояние, но где будет уже известно что за выигрыш.*/
    PRECURSOR_STARTING : 9001,

    /** When player just observes any previous states result. There are winnings,
        * bets, combinations, etc, but player already played it at previous login,
        * so just skip this state with spin() call. */
    FINAL : 10,

    /** Состояние окончания фригеймов или бонуса, где отображаются барабаны и игрок должен, обычно, решить что ему делать дальше: войти в риск или забрать выигрыш.*/
    FINISH : 11
};

function UrlParamsToObject()
{
    var result = {};
    var pairs = window.location.href.slice( window.location.href.indexOf( '?' ) + 1 ).split( '&' );
    
    for ( var i = 0; i < pairs.length; ++i )
    {
        var pair = pairs[ i ].split( '=' );
        var value = pair[ 1 ];
        if ( value === undefined )
        {
            value = true;
        }
        result[ pair[ 0 ] ] = value;
    }
    return result;
}

/**
* Такой callback передаётся во все асинхронные функции сервера для обработки ошибок. В результате одной асинхронной операции вызывается только либо этот callback, либо onResult, либо onFatal. Вызов этого callback'а хоть и означает ошибку, но такую что после неё можно восстановиться.
* @callback onFail
* @param {String} Текст ошибки.
*/

/**
* Вызывается при возникновении ошибки, от которой невозможно восстановиться.
* @callback onFatal
* @param {String} Текст ошибки.
*/

/**
* Constructs Server object.
* @class
* @constructor
* @param {gameId} Идентификатор, отличающий игру от других в запросах на сервер. У ArabianTales 37.
* @param {String} name Попросили разработчики сервера указывать текстовое имя игры.
* @param {Object[]} bonusSettings Настройки всех бонусов в зависимости от игры для верификации данных, уникальных для игрока, которые игра хранит на сервере. Позволяет перенести логику верификации (и оборачивания вообще) из каждой конкретной игры сюда путём указаний различий в виде этих настроек. Массив, по одному объекту на каждый тип бонуса.
* @param {number} bonusSettings[].gameType Константа из Server.GAME_TYPE . Для какого типа бонуса эта настройка.
* @param {number} bonusSettings[].from От скольки начинается диапазон возможных выборов игроком. Включительно.
* @param {number} bonusSettings[].to На скольки заканчивается диапазон возможных выборов игроком. Включительно.
* @param {bool} bonusSettings[].exclusive True если каждый выбор в бонусе игрок может сделать только один раз.
* @property onCreditsPoll function( credits : int ) Если установлено, то вызывается когда кредиты обновляются при простое игры (игрок при этом ничего не делает). Это должны подхватить интерфейсы и отобразить.
* @classdesc This class provides for end clients high level network API for interaction
* with game server.
* @name Server
* */
export default class Server
{
    constructor( gameId, name, bonusSettings, totalizator )
    {
        this.gameId = gameId;
        this.name = name;
        this.bonusSettings = bonusSettings;
        this.totalizator = totalizator
        
        this.net_service = $ ? $.ajax : undefined
        
        this.$net = new Stream( "net" );
        this.$balancePoll = new Stream( "balance_poll" );
        this.$progressive_jackpot = new Stream( "progressive_jackpot" )
        this.$error = new Stream( "error" );

        this.requestsPending = 0;
        
        //для того чтобы на терминалах новые игроки не играли по ставкам предыдущих игроков, мы сбрасываем ставку в минимальную в первом ответе от сервера:
        this.virginSession = true;

        //этот "костыль" отключили - теперь игра обязательно должна хоститься в том же домене что и лобби:
        /*//в некоторых случаях выделение домена не работает, например когда домен как IP-адрес или состоит из нескольких имён (amazon.co.uk):
        //чтобы куки записывались и читались в тот же (главный) домен что и лобби:
        cookiesSettings.domain = window.location.hostname.substring(
            window.location.hostname.lastIndexOf(
                ".",
                window.location.hostname.lastIndexOf( "." ) - 1
            )
            + 1
        );
        //чтобы 192.168.0.101 НЕ превращалось в 0.101:
        if ( ! isNaN( cookiesSettings.domain.split( '.' )[ 0 ] ) )
        {
            cookiesSettings.domain = window.location.hostname;
        }*/
        console.log( "All the cookies will be written/read to/from " + JSON.stringify( cookiesSettings ) );

        this.urlParameters = UrlParamsToObject();
        
        if ( this.urlParameters[ 'nolobby' ] === undefined )
        {
            var lobbyCookie = cookies.get( 'lobby_url' );
            if ( lobbyCookie && lobbyCookie.length > 0 )
            {
                console.log( 'Boot: Lobby URL cookie: ' + lobbyCookie );
                this.lobbyURL = decodeURIComponent( lobbyCookie );
            }
            //for now game is hosted throughout multiple lobby pages and so we do not assume any default lobby anymore:
            /*else
            {
                console.error( "'Lobby' URL was NOT defined. Using default one.");
                this.lobbyURL = '/wbg_lobby';
            }*/
        }

        if (
            NODE_ENV === 'development' &&
            this.urlParameters[ 'scenario' ] !== undefined &&
            this.urlParameters[ 'stage' ] !== undefined &&
            this.urlParameters[ 'lines' ] !== undefined
        )
        {
            this.spinCase = {
                scenario : parseInt( this.urlParameters[ 'scenario' ] ),
                stage : parseInt( this.urlParameters[ 'stage' ] ),
                lines : parseInt( this.urlParameters[ 'lines' ] ),
                multiplier : this.urlParameters[ 'bet' ] !== undefined ? parseInt( this.urlParameters[ 'bet' ] ) : 1,
                jackpot : this.urlParameters[ 'jackpot' ]
            };
        }

        this.observerMode = this.urlParameters[ 'view_mode' ] == "1";

        /**
        * Инициализируется после login() или handleLobby(), после чего можно spin()/freespin()/risk()...
        * @type {{spec: string, settings: string, credits: string, state: string}}
        * @memberOf Server
        */
        this.loginData =
        {
            spec : "not_set",
            settings : "not_set",
            credits : "not_set",
            state : "not_set"
        };

        //TODO:
        /*initMonitorState(
            this,
            onResult,
            onFail,
            onFatal
        );*/
        
        /** Возможные варианты завершения раунда риска.*/
        this.RISK_RESULT = {
            /** Игрок правильно угадал - его ждёт следующий раунд.*/
            WIN : 1,
            /** Игрок проиграл - его выкинуло в состояние FINAL с барабанами.*/
            LOSE : 2,
            /** Игрок выиграл в текущем раунде, но играть дальше ему нельзя из-за ограничения максимального выигрыша - его выкинуло в состояние FINAL с барабанами.*/
            WIN_AND_CAPPED : 3,
            /** Игрок совершил какой-то выбор (не имеет значения какой), но из-за ограничения выигрыша прямо в текущем раунде (играть ему БЫЛО нельзя) его сразу выкинуло в FINAL.*/
            CAPPED : 4,
            /** Игрок отказался играть и забрал выигрыш.*/
            COLLECT : 5,
            /** Ничья в пятикарточном риске.*/
            DRAW : 6,
        };

        if (NODE_ENV === 'development') {

            /** Начислить кредиты читерским способом.
                * @param onResult function( balance : { gameable : int, cashable : int, currency_id, denomination : int } ) gameable == credits == coins
                * @param {onFail} onFail function( error : String )
                * @memberOf Server.
                * */
            this.credit = function(onResult, onFail) {
                var server = this;

                request(
                    server,
                    [
                        OPERATION_ID.CODE_ACTIVATE,
                        OPERATION_ID.BALANCE_GET
                    ],
                    [
                        undefined,
                        function(getBalance) {
                            server.balance = getBalance;
                        }
                    ],
                    [
                        {
                            code : "value:500"
                        },
                        undefined
                    ],
                    function() {
                        onResult(server.balance);
                    },
                    onFail,
                    function()
                    {
                    }
                );
            };
        }//if development
    }

    /**
    * Осуществляет логин на сервере когда игра запускается БЕЗ лобби. Для удобства разработки/отладки.
    * @param {url} На какой сервер подключаться. Сейчас используется https://wbgdev.ngmcasino.com/wbg_server/index.php?r=game
    * @param {String} username username to login
    * @param {String} password password to login
    * @param onLogin function( result : Object ). result's format sample is not available yet for API version 2.0.
    * @param {onFail} onFail function( error : String ) When something bad happens at any stage of login. No "onLogin" will be called later on.
    * @param {onFatal} onFatal
    * @param {Object} spinCase Заставить сервер ввести игрока в указанное состояние, если разработчик хочет протестировать какую-то конкретную ситуацию: что будет после этого логина (независимо от предыдущих состояний). Если разработчик хочет продолжить играть с предыдущего состояния, то undefined.
    * @param {Number} spinCase.scenario Идентификатор отладочного сценария, на который будет установлено состояние игрока перед логином.
    * @param {Number} spinCase.stage Идентификатор стэйджа внутри сценария или 0 если undefined.
    * @param {Number} spinCase.lines По каким линиям играть. Могут выпасть фригеймы или не выпасть в зависимости от этого значения. То есть, ключом к комбинации символов на барабане является комбинация идентификатора сценария И количества линий.
    * @param debug_project_name 'SRS' если это СРС игра и она запускается прямо из ЭТОЙ игры, а не из лобби (для отладки).
    * @memberOf Server
    * */
    login(
        url,
        username,
        password,
        onLogin,
        onFail,
        onFatal,
        options,
        debug_project_name,
        spinCase
    )
    {
        this.url = url;
        
        if ( spinCase !== undefined )
        {
            this.spinCase = spinCase;
        }

        this.ok = true;
        this.requestsPending = 0
        delete this.postponedRequest
        delete this.sessionRefreshPending
        delete this.failed;

        server_login(
            this,
            username,
            password,
            onLogin,
            onFail,
            onFatal,
            options
        );
    };

    handleMonitoringState(
        server,
        onResult,
        onFail,
        onFatal
    )
    {
        console.log( "Monitor: entering \"monitor\" game mode." );

        //...то игровые данные запрашивать не нужно - ожидаем от игры вызова readyToMonitor() ...
        server.monitor = JSON.parse( decodeURIComponent( cookies.get( 'credential_view' ) ) );
        console.log( "Monitoring credentials: " + decodeURIComponent( cookies.get( 'credential_view' ) ) );
        //течение времени на клиенте, параллельное серверному:
        setInterval(
            function()
            {
                //если игра ещё даже не указала callback проигрывания state'ов:
                if ( ! ( server.onMonitorNext instanceof Function ) )
                {
                    console.log( "Monitor: monitoring callback wasn't specified yet." );
                    return;
                }

                //если от сервера ещё не пришёл ответ на запрос получения данных для мониторинга:
                if ( server.monitorDelta === undefined )
                {
                    console.log( "Monitor: monitoring condition wasn't even initialized yet." );
                    return;
                }

                var currentSeconds = ( new Date ).getTime() / 1000.0;

                //если выделенный сервером временной период анимирования завершился, то пора запрашивать новые данные для мониторинга:
                if ( currentSeconds + server.monitorDelta >= server.monitorServerEnd )
                {
                    //если данные для мониторинга УЖЕ запрашиваются:
                    if ( server.requestingMonitoringData === true )
                    {
                        console.log( "Monitor: next portion of monitoring data already requested, waiting for it ..." );
                        return;
                    }

                    console.log( "Monitor: requesting monitoring data ..." );

                    requestMonitoringData(
                        server,
                        server.onFail,
                        server.onFatal
                    );
                    return;
                }

                //важно чтобы эта проверка была ПОСЛЕ возможного запроса новых данных чтобы анимация игры не мешала течению времени синхронизации records с сервером:
                //если игра не готова анимировать следующие state'ы (занимается анимированием текущего или почему-то ещё):
                if ( server._readyToMonitor !== true )
                {
                    console.log( "Monitor: not yet ready to monitor next portion." );
                    return;
                }

                //если больше не осталось данных для мониторинга, то делать ничего не нужно пока не придут новые (а они придут когда наступит время их запрашивать):
                if ( ! server.monitorData || ! server.monitorData.records || server.monitorData.records.length < 1 )
                {
                    console.log( "Monitor: no data to monitor remaining, nothing to do." );
                    return;
                }

                var monitoringCandidate = server.monitorData.records[ 0 ];

                var currentServerSeconds = currentSeconds + server.monitorDelta;
                //если, таки, наступила пора проигрывать очередной state:
                if ( currentServerSeconds >= monitoringCandidate.created_timestamp )
                {
                    server.monitorData.records.shift();

                    //если этот state уже проигрывали в рамках текущей сессии, то больше проигрывать не нужно:
                    if ( server.monitorIndex === undefined )
                    {
                        //вообще первый state: просто сохранить индекс чтобы избежать проигрывания в будущем и начать отсчёт проигранных state'ов:
                        server.monitorIndex = monitoringCandidate.index;
                    }
                    else
                    {
                        //уже проигрывался (.index - это порядковый номер state'а в пакете анимации):
                        if ( monitoringCandidate.index <= server.monitorIndex )
                        {
                            return;
                        }
                        server.monitorIndex = monitoringCandidate.index;
                    }

                    var monitoringState = monitoringCandidate.operations[ OPERATION_ID.STATE_GET ];
                    var monitoringBalance = monitoringCandidate.operations[ OPERATION_ID.BALANCE_GET ];

                    console.log( "Monitoring state " + server.stageTypeName( monitoringState.stage.type_id ) + " | #" + monitoringCandidate.index );

                    //для того чтобы отправить в игру выбранную карту в риске ТОЛЬКО если предыдущее состояние (именно и лишь предыдущее потому что мы специально пропускаем состояние "risk result" в рамках передачи для отображения в игру) было результатом выбора карты в риске ("risk result"):
                    var previousState = server.monitorPrevious;
                    server.monitorPrevious = monitoringState;

                    //в игру мы отправляем только события "RISK_MAIN", так как она сама знает какую карту выбрали:
                    if ( isRiskResult( monitoringState ) )
                    {
                        server.riskResultState = server.riskState = monitoringState;
                        console.log( "    skipping \"risk result\" state until next will be fetched." );
                        return;
                    }
                    //если ни текущее состояние ни предыдущее не являются результатом риска, то monitorPretend не должен возвращать результат риска для предыдущего состояния (это также последствие реализации обхода RISK_RESULT для игры):
                    else if ( isRiskResult( previousState ) !== true )
                    {
                        console.log( '  previous state was NOT a result of risk, so clearing it.');
                        server.riskResultState = undefined;
                    }

                    //высчитываем секунды, за которое игра должна управиться отображать (анимировать) текущий state:
                    var playIn = null;
                    if ( server.monitorData.records.length > 0 )
                    {
                        playIn = server.monitorData.records[ 0 ].created_timestamp - currentServerSeconds;
                    }
                    else
                    {
                        playIn = server.monitorServerEnd - currentServerSeconds;
                    }

                    console.log( "    ... in " + playIn + " seconds" );

                    server.monitorNextRecord = monitoringCandidate;

                    server._readyToMonitor = false;

                    //какую карту игрок выбрал (выберЕТ) в риске:
                    var riskChoice = server.RISK_CHOICE.UNDEFINED;
                    if ( previousState && isRiskResult( previousState ) )
                    {
                        riskChoice = resolveRiskChoice( server, server.riskState );
                    }
                    console.log( "   ... risk choice: " + riskChoice );

                    server.onMonitorNext(
                        {
                            state : monitoringState,
                            seconds : playIn,
                            gameType : resolveGameType( server, monitoringState ),
                            riskChoice : riskChoice,
                            lines : monitoringState.line_count,
                            multiplier : monitoringState.multiplier,
                            credits : resolveCredits( monitoringBalance ),
                            scenarioData : monitoringCandidate.operations[ OPERATION_ID.CLIENT_DATA_SCENARIO_GET ]
                        }
                    );
                }
            },
            //вобщем, это функция которая должна вызываться "примерно каждый кадр": с течением времени:
            50
        );
    }

    /**
        * Проинициализироваться при запуске игры из лобби.
        * @param onLogin function( result : Object ). result's format sample is not available yet for API version 2.0.
        * @param {onFail} onFail function( error : String ) When something bad happens at any stage of login. No "onLogin" will be called later on.
        * @param {onFatal} onFatal
        * @param {Object} monitor !== undefined если игра запускается в режиме мониторинга пользователя, идентификация которого представлена в этом объекте.
        * @param {String} monitor.login Terminal id || RFID || username пользователя, в режиме мониторинга которого запускается эта игра.
        * @param {Number} monitor.identity_type_id Тип идентификации пользователя, в режиме мониторинга которого запускается эта игра. Константа из SERVER_IDENTITY_TYPE.
        * @param {Object} spinCase \sa Server.login
        * @memberOf Server
        */
    handleLobby(
        onResult,
        onFail,
        onFatal,
        options
    )
    {
        var server = this;
        
        function injectCreditingBeforeOnResult()
        {
            var onResultArguments = arguments;
            
            if (
                server.virginSession &&
                NODE_ENV === 'development' &&
                server.urlParameters[ 'credits' ] !== undefined
            )
            {
                server.credit(
                    function()
                    {
                        onResult.apply( undefined, onResultArguments );
                    },
                    onFail
                );
            }
            else
            {
                onResult.apply( undefined, onResultArguments );
            }
        }
        
        if ( LOBBYLESS_ENV )
        {
            this.login(
                //develop:
                "https://wbgdev.ngmcasino.com/wbg_server/index.php?r=game"
                /*//stable:
                "http://stable_wbg.nbgsuper.com/WebBasedGames/index.php?r=game"*/,
                /*'srs_iru3'*/'iru3',
                "iru3",
                injectCreditingBeforeOnResult,
                onFail,
                onFatal,
                options
            );
            return;
        }

        if ( server.lastHandleLobby )
        {
            var date = new Date;
            //чтобы игра вызывала реконнект не чаще чем через необходимый промежуток времени ожидания (как мы договорились с серверной разработкой, для уменьшения количества реконнектов):
            if ( date.getTime() - server.lastHandleLobby.getTime() < 4000 )
            {
                server.enterFatal( onFatal, 'Too frequent retry request' );
                return;
            }
            server.lastHandleLobby = date;
        }
        else
        {
            server.lastHandleLobby = new Date;
        }

        function invoke()
        {
            //первая инициализация - теперь можно общаться с сервером (включая поллинг):
            //... или снова можно общаться с сервером:
            server.ok = true;
            delete server.failed;
            delete server.stateOrder;

            //если игра запускается в режиме мониторинга:
            if ( server.observerMode )
            {
                handleMonitoringState(
                    server,
                    injectCreditingBeforeOnResult,
                    onFail,
                    onFatal
                );
            }
            else
            {
                requestLoginData(
                    server,
                    injectCreditingBeforeOnResult,
                    onFail,
                    onFatal,
                    options
                );
            }
        }

        //просто первое подключение сессии в рамках текущей сессии:
        if ( server.failed === undefined )
        {
            init( server );
            
            try
            {
                server.credential = JSON.parse( decodeURIComponent( cookies.get( 'credential' ) ) );
                if ( server.credential.length < 1 )
                {
                    throw 'wrong credential';
                }
                                    
                server.url = decodeURIComponent( cookies.get( 'url' ) );
                if ( server.url.length < 1 )
                {
                    throw 'wrong url';
                }
            }
            catch ( e )
            {
                server.enterFatal( onFatal, 'cookies read fail: ' + e.message, true );
                return;
            }

            invoke();
        }
        //в случае восстановления состояния повторное подключение можно начинать не раньше чем через 5 секунд после возникновения ошибки:
        else
        {
            var timeout = server.failed + 5000 - Date.now();
            if ( timeout < 0 )
            {
                timeout = 0;
            }
            console.log( 'Reconnecting after ' + timeout + ' ms ...' );
            setTimeout( invoke, timeout )
        }
    };

    /** Должна вызываться игрой когда очередной state был отображён.*/
    readyToMonitor()
    {
        this._readyToMonitor = true;
    };
    
    //чтобы работало через this accessor:
    get GAME_TYPE() { return GAME_TYPE; }

    /**
        * Returns game type name
        * @param {Number} gameType game type identifier
        * @return {String} game type symbolic name
        * @memberOf Server
        * */
    gameTypeName( gameType )
    {
        for (var name in this.GAME_TYPE) {
            if (this.GAME_TYPE[name] === gameType) {
                return name;
            }
        }

        //эта функция используется для отладки и, обычно, когда gameType() УЖЕ провалилась (не соответствует ожиданиям и т.д.) и, скорее всего, провалилась в try/catch, поэтому здесь выбрасывание exception'а не только необязательно, но и противоречиво:
        return "UNKNOWN GAME TYPE";
    };
    
    stageTypeName( stageType )
    {
        for ( var name in SERVER_STAGE_TYPE )
        {
            if ( SERVER_STAGE_TYPE[ name ] == stageType )
            {
                return name;
            }
        }
    };

    /**
        * Requests data for spin (no, it actually makes reels spinning on server-side). Be careful to not call it when playing Risk game, freegames, etc.
        * @param {Number} lines lines playing
        * @param {Number} multiplier multiplier playing
        * @param onSpin function( result : Object ). result's format sample is not available yet for API version 2.0
        * @param {onFail} onFail function( error : String ) When something bad happens at any stage of login. No "onLogin" will be called later on
        * @param {onFatal} onFatal
        * @memberOf Server.
        * */
    spin(
        lines,
        multiplier,
        onSpin,
        onFail,
        onFatal,
        skipToRisk
    )
    {
        //в новом [начинающемся] сценарии ещё не было риска:
        this.riskState = undefined
        
        if ( this.monitor )
        {
            monitorPretend( this, onSpin );
            return;
        }

        initiate_spin(
            this,
            lines,
            multiplier,
            onSpin,
            onFail,
            onFatal,
            skipToRisk
        );
    };

    /** Перейти в состояние окончания фригеймов или бонуса, где отображаются барабаны и игрок должен, обычно, решить что ему делать дальше: войти в риск или забрать выигрыш.
        * @param onResult function() Вызывается когда ответ от сервера получен и get'терами Server'а можно получить состояние.
        * @param onFail {onFail}
        * @param onFatal {onFatal}
        * @memberOf Server
        */
    finish(
        onResult,
        onFail,
        onFatal
    )
    {
        if ( this.monitor )
        {
            monitorPretend( this, onResult );
            return;
        }

        goNextStage(
            this,
            SERVER_STAGE_TYPE.FINISH,
            onResult,
            onFail,
            onFatal
        );
    };

    /**
        * Accepts win on server.
        * @param onResult function( state : Object ) Вызывается с ответом от сервера
        * @param {onFail} onFail function( error : String ) Если что-то пошло не так.
        * @param {onFatal} onFatal
        * @memberOf Server
        * */
    takeWin(
        onResult,
        onFail,
        onFatal
    )
    {
        if ( this.monitor )
        {
            monitorPretend( this, onResult );
            return;
        }

        //если takeWin() уже вызывали:
        if (this.lastState.stage.type_id === SERVER_STAGE_TYPE.FINAL) {
            this.enterFail( onFail, "network_api::Server::takeWin(): already final stage" );
            return;
        }
        
        if ( this.gameType == this.GAME_TYPE.RISK )
        {
            this.riskResult = this.RISK_RESULT.COLLECT;
        }

        goNextStage(
            this,
            SERVER_STAGE_TYPE.FINAL,
            onResult,
            onFail,
            onFatal
        );
    };

    /**
        * Requests free spin data (also no: it actually MAKES freespin AND also retreives data for it).
        * @param {Function} onResult success callback
        * @param {onFail} onFail failure callback
        * @memberOf Server.
        * */
    freespin(
        onResult,
        onFail,
        onFatal
    )
    {
        if ( this.monitor )
        {
            monitorPretend( this, onResult );
            return;
        }

        resolveNextStage(
            this,
            onResult,
            onFail,
            onFatal,
            undefined,
            undefined
        );
    };

    /**
        * Getter. Returns true if specified bonus is available and can be used to enter it with proceedBonus().
        * @param bonusType One of Server.GAME_TYPE.BONUS_... constants.
        */
    isBonusAvailable(
        bonusType
    )
    {
        var server = this;
        //looking for specified bonus:
        var bonus = this.lastState.way_map.find( function ( nextStage )
        {
            switch ( bonusType )
            {
                case server.GAME_TYPE.BONUS_1:
                    return nextStage == SERVER_STAGE_TYPE.BONUS_1;
                case server.GAME_TYPE.BONUS_2:
                    return nextStage == SERVER_STAGE_TYPE.BONUS_2;
                case server.GAME_TYPE.BONUS_3:
                    return nextStage == SERVER_STAGE_TYPE.BONUS_3;
            }
            return false;
        } );
        if ( bonus != undefined )
        {
            return true;
        }
    };

    /**
        * Switch state on the server to the specified bonus one.
        * @param bonusType One of constants from Server.GAME_TYPE.BONUS_... .
        * @param choice Индекс действия внутри бонуса. Обычно [0, 4]. Смысл определяется посредством bonusSettings в конструкторе Server
        */
    proceedBonus(
        bonusType,
        choice,
        onResult,
        onFail,
        onFatal
    )
    {
        var server = this;

        function process()
        {
            verifyBonusData( server );
            return {
                math : server.lastState.stage.math,
                scenarioData : server.scenarioData
            }
        }

        if ( this.monitor )
        {
            monitorPretend(
                this,
                function()
                {
                    onResult( process() );
                }
            );
            return;
        }

        var serverBonusType = undefined;
        switch ( bonusType )
        {
            case this.GAME_TYPE.BONUS_1:
                serverBonusType = SERVER_STAGE_TYPE.BONUS_1;
                break;
            case this.GAME_TYPE.BONUS_2:
                serverBonusType = SERVER_STAGE_TYPE.BONUS_2;
                break;
            case this.GAME_TYPE.BONUS_3:
                serverBonusType = SERVER_STAGE_TYPE.BONUS_3;
                break;
        }

        console.log( 'Proceeding bonus to ' + choice + ' from ' + JSON.stringify( server.scenarioData ) + ' ...' );

        if ( bonusType !== server.gameType || ! server.scenarioData )
        {
            server.scenarioData = [];
        }
        server.scenarioData.push( choice );

        request(
            server,
            [
                OPERATION_ID.WAY_SELECT,
                OPERATION_ID.STATE_GET,
                OPERATION_ID.BALANCE_GET,
                OPERATION_ID.CLIENT_DATA_SCENARIO_GET
            ],
            [
                undefined,
                function( getState )
                {
                    server.lastState = getState;
                },
                function( balance )
                {
                    server.balance = balance;
                },
                function( scenarioData )
                {
                    server.scenarioData = scenarioData;
                }
            ],
            [
                {
                    type_id : serverBonusType,
                    //теперь данные записывается внутри ключевого operation'а дабы обойти проблему рассинхрона путём использования транзакций уровня operation'ов (а они именно на этом уровне, а не на уровне запросов):
                    scenario_data : server.scenarioData
                }
            ],
            function()
            {
                onResult( process() );
            },
            onFail,
            onFatal
        );
    };
    
    isJackpotAvailable()
    {
        return this.lastState.way_map.find( function( nextStage )
        {
            return nextStage == SERVER_STAGE_TYPE.JACKPOT
        } ) != undefined
    }
    
    enterJackpot(
        onResult,
        onFail,
        onFatal
    )
    {
        if ( this.monitor )
        {
            monitorPretend( this, onResult )
            return
        }
        
        var server = this
        
        requestPostponedScenario(
            server,
            [
                OPERATION_ID.WAY_SELECT,
                OPERATION_ID.STATE_GET,
                OPERATION_ID.BALANCE_GET
            ],
            [
                undefined,
                function( state )
                {
                    server.lastState = state
                },
                function( balance )
                {
                    server.balance = balance
                }
            ],
            [
                {
                    type_id : SERVER_STAGE_TYPE.JACKPOT
                }
            ],
            onResult,
            onFail,
            onFatal
        )
    }

    /**
        * TODO Description needed.
        * @param onResult function( state : Object ) Пока не знаю формат состояния внутри риска.
        * @param {onFail} onFail
        * @param {Number} type В какой тип риска зайти если сервер предоставляет вариации для текущей игры. Можно оставить undefined если сервер предоставляет только один тип риска или нужно взять первый попавшийся. Константа из RISK_TYPE
        * @memberOf Server.
        * */
    enterRisk(
        onResult,
        onFail,
        onFatal,
        type
    )
    {
        if ( this.monitor )
        {
            monitorPretend( this, onResult );
            return;
        }

        if ( type === undefined )
        {
            type = this.loginData.spec.risks[ 0 ].type_id;
        }
        
        //risk also uses scenarioData so making sure it won't be polluted by 

        var server = this;
        request(
            server,
            [
                OPERATION_ID.SCENARIO_RISK_BEGIN,
                OPERATION_ID.STATE_GET,
                OPERATION_ID.RISK_HISTORY_GET,
                OPERATION_ID.BALANCE_GET,
                OPERATION_ID.CLIENT_DATA_SCENARIO_GET
            ],
            [
                undefined,
                function( state )
                {
                    server.lastState = state;
                    onResult( resolveDealerCard( state ) );
                },
                function( riskHistoryData )
                {
                    server.riskHistoryData = riskHistoryData;
                },
                function( balance )
                {
                    server.balance = balance;
                },
                function( scenarioData )
                {
                    server.scenarioData = scenarioData;
                }
            ],
            [
                {
                    risk_id : type
                },
                undefined,
                {
                    risk_id : type
                }
            ],
            undefined,
            onFail,
            onFatal
        );
    };
    
    get RISK_CHOICE() { return RISK_CHOICE; }

    /**
        * Выбирает карту в риске.
        * @param {Object} userData { choice : Number, step : Number }, где choice: константа из Server.RISK_CHOICE или идентификатор выбираемой карты если это "5-тикарточный риск".
        * @param onResult Не используется в RED/BLACK риске. В 5-тикарточном: { dealer : Card, cards : [ 4 ], playerChoice : Int }, где dealer карта дилера, cards : массив из четырёх уже открытых карт, playerChoice - какую карту выбрал игрок (индекс в cards).
        * @param {onFail} onFail
        * @param {onFatal} onFatal
        * @memberOf Server
        * */
    chooseAtRisk(
        userData,
        onResult,
        onFail,
        onFatal
    )
    {
        if ( this.monitor )
        {
            monitorPretend( this, onResult );
            return;
        }

        var server = this;

        var serverStageType;
        
        const step = server.scenarioData ? server.scenarioData.step : 1;
        const scenario_data = {
            choice : userData,
            step : step + 1
        };

        if ( this.lastState.stage.risk_id == RISK_TYPE.FIVE_CARDS )
        {
            serverStageType = SERVER_STAGE_TYPE.RISK_RESULT;
        }
        //выбор карты реализован на сервере как вилка стэйджей:
        else
        {
            //в BLACK_WHITE риске это и есть выбор карты:
            switch ( userData )
            {
                case server.RISK_CHOICE.RED:
                    serverStageType = SERVER_STAGE_TYPE.RISK_RESULT_RED;
                    break;
                case server.RISK_CHOICE.BLACK:
                    serverStageType = SERVER_STAGE_TYPE.RISK_RESULT_BLACK;
                    break;
                default:
                    throw Error( "Server: chooseAtRisk(): undefined choice" );
            }
        }
        
        //защита от чрезмерного выигрыша в риске на сервере реализована как отсутствие соответствующего выбора в way_map:
        serverStageType = availableOrFinal( serverStageType, server.lastState );
        if ( serverStageType == SERVER_STAGE_TYPE.FINAL )
        {
            console.warn( 'Seems like potential winning is too high: server forces us to switch directly to final state ...' );
            //чтобы можно было прочитать win_multiplier в riskCapped:
            server.riskState = server.lastState;
            
            server.riskResult = server.RISK_RESULT.CAPPED;
        }
        
        //так как аватар "помогает" игре и сам переходит в FINAL, то в случае наличия джекпота нужно перейти на джекпот:
        if ( serverStageType == SERVER_STAGE_TYPE.FINAL )
        {
            serverStageType = availableOrFinal( SERVER_STAGE_TYPE.JACKPOT, server.lastState )
        }

        requestPostponedScenario(
            server,
            [
                OPERATION_ID.WAY_SELECT,
                OPERATION_ID.STATE_GET,
                OPERATION_ID.BALANCE_GET,
                OPERATION_ID.CLIENT_DATA_SCENARIO_GET
            ],
            [
                undefined,
                function( riskResultState )
                {
                    console.log( "RISK RESULT: " + JSON.stringify( riskResultState ) );

                    server.lastState = riskResultState;
                },
                function( balance )
                {
                    server.balance = balance;
                },
                function( scenarioData )
                {
                    server.scenarioData = scenarioData;
                }
            ],
            [
                {
                    type_id : serverStageType,
                    //теперь данные записывается внутри ключевого operation'а дабы обойти проблему рассинхрона путём использования транзакций уровня operation'ов (а они именно на этом уровне, а не на уровне запросов):
                    //здесь нужно бы как-то сохранять данные ПАРАЛЛЕЛЬНО с данными возможного бонуса, но тогда придётся делать дополнительные предварительный запрос для получения данных бонуса, что замедлит игру, а гарантии всё-равно не даст так как мы предполагаем возможность играть сразу в нескольких вкладках (тогда данные всё-равно могут пропасть):
                    scenario_data : scenario_data
                }
            ],
            function()
            {
                //проскочили сразу в FINAL из-за чрезмерного выигрыша:
                if ( server.lastState.stage.type_id == SERVER_STAGE_TYPE.FINAL )
                {
                    onResult()
                }
                else if ( server.lastState.stage.type_id == SERVER_STAGE_TYPE.JACKPOT )
                {
                    onResult()
                }
                else
                {
                    //частично избавляемся от "граблей" проскока риска - пусть сначала завершится анимация проигрыша (проблема "граблей" особенно остро встала из-за выпадения джекпота когда от выпадает как только игрок выбирает проигрышную карту, не успев увидеть что он таки проиграл):
                    /*proceedRisk(
                        server,
                        server.lastState,
                        onResult,
                        onFail,
                        onFatal
                    )*/
                    onResult()
                }
            },
            onFail,
            onFatal
        );
    };

    /**
        * Отправить произвольное сообщение на сервер, которое будет добавлено в логи с префиксом времени прихода этого сообщения. Сервер никак это не обрабатывает, никакие команды не выполняет - только добавляет в логи. Логи можно посмотреть тут для "stable" http://debug_wbg.nbgsuper.com/WebBasedGames/logs/ и тут для "debug" http://debug.fgms.info/WebBasedGames/logs/
        * @param message Текстовое сообщение.
        * @param onSuccess Вызывается когда приходит ответ от сервера о корректном принятии лога. Смысла использовать (навешивать какой-либо функционал) это нет.
        * @param {onFail} onFail
        * @memberOf Server
        */
    trace( message )
    {
        return;
        
        request(
            this,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            message
        );
    };
    
    /** Перейти в табличный режим с математикой текущей игры.*/
    goTableMode()
    {
        location =
            //в лобби вроде как должны были уже исправить этот баг:
            //'https://' +
            cookies.get( 'table_mode_url' ) + '/?game_id=' + this.gameId
    };
    
    /** Вернуться в игру, из которой вошли в текущий табличный режим.*/
    returnFromTableMode()
    {
        window.history.back();
    }
    
    get math() { return this.lastState.stage.math || {} }
    
    /**
        * Get slot symbols.
        * @returns {Number[]} last spin slot symbols. Rows first.
        * @memberOf Server
        */
    get symbols()
    {
        if (this.lastState.stage.math) {
            return this.lastState.stage.math.symbols;
        }
        return null;
    }
    
    /**
        * @returns Текущее количество кредитов по версии сервера. Изменяется после начала сценария (вычет ставки), получения выигрыша (takeWin()).
        * @memberOf Server
        */
    get credits()
    {
        return resolveCredits( this.balance );
    }

    /**
        * @returns Последовательный номер (НЕ индекс: первый фриспин имеет номер "1") текущего фриспина в рамках фригеймов. Если фригеймы были только что выиграны (сейчас основная игра), то 0.
        * @memberOf Server
        */
    get freespinNumber()
    {
        if ( this.lastState.stage.math.currentFreeGameNumber )
        {
            return parseInt( this.lastState.stage.math.currentFreeGameNumber );
        }
        return 0;
    }

    /**
        * @returns Сколько ещё выиграно фриспинов в рамках текущего фриспина.
        * @memberOf Server
        */
    get freespinsIncrease()
    {
        if ( this.lastState.stage.math.freeGamesCountIncrease )
        {
            return parseInt( this.lastState.stage.math.freeGamesCountIncrease );
        }
        return 0;
    }

    /**
        * @returns Сколько всего фриспинов в текущем фригейме, включая все дополнительные, или сколько будет (не считая возможные будущие дополнительные) если фриспины были только что выиграны в основной (обычной) игре. Например, в основной игре выпало 7 фриспинов, то число будет 7; затев во фриспинах выпадает ещё 5 и, в дальнейшем, будет 12. Если в текущем фриспине были выиграны ещё фриспины, то также прибавляет и их.
        * @memberOf Server
        */
    get freespinsCount()
    {
        if ( this.lastState.stage.math.freeGamesCount )
        {
            return parseInt( this.lastState.stage.math.freeGamesCount ) + this.freespinsIncrease;
        }
        return parseInt( this.lastState.stage.math.freeGamesCountIncrease );
    }

    //TODO: implement fractional arythmetics:
    /**
        * @returns Amount of winnings within current spin (or freespin if it's freespin currently).
        * @memberOf Server
        */
    get spinWinInCoins()
    {
        return parseInt( this.lastState.stage.win ) * parseInt( this.lastState.multiplier );
    }

    //TODO: implement fractional arithmetic:
    /**
        * @returns Gross amount of winnings (sum of all spinWin() for every spin/freespin) within current scenario.
        * @memberOf Server
        */
    get totalWinInCoins()
    {
        return stateWinInCoins( this.lastState );
    }

    /**
        * @returns true если следующая стадия - это freespin и нужно будет вызвать Server.freespin().
        * @memberOf Server
        */
    get isFreespinAvailable()
    {
        if ( this.lastState.stage.type_id != SERVER_STAGE_TYPE.FINAL )
        {
            //looking for freegame:
            if ( $.inArray( SERVER_STAGE_TYPE.FREEGAME, this.lastState.way_map ) >= 0 )
            {
                return true;
            }
        }
        return false;
    }

    /**
        * Utility function to check if player may choose enter risk or take winning avoiding it.
        * @memberOf Server
        */
    get isRiskAvailable()
    {
        //в математике сервера есть баг где по логике течения сценария риск доступен, однако в игре его вообще нету, но такая проверка на сервере повышает нагрузку - перекинули её на клиент:
        if ( ! this.loginData.spec.risks || this.loginData.spec.risks.length < 1 )
        {
            return false;
        }
        
        return this.lastState.stage.risk_available;
    }
    /**
        * @returns {Number} Масть текущей карты в риске (очевидно, доступно только после выбора между "чёрным" и "красным"). Индекс в массиве спецификации, например в "Hearts" | "Diamonds" | "Spades" | "Clubs".
        * @see riskSuitName
        * @memberOf Server
        */
    get riskSuit()
    {
        if ( this.riskState && this.riskState.stage && this.riskState.stage.math )
        {
            return this.riskState.stage.math.suit;
        }
        //это нормально:
        //console.error( 'Server.get riskSuit(): seems like not even a risk state.' );
        return undefined;
    }
    /**
        * @returns {Number} от 0 до 12, где 0 - это "двойка", 12 - это "туз".
        * @memberOf Server
        */
    get riskNominal()
    {
        if ( this.riskState && this.riskState.stage && this.riskState.stage.math )
        {
            return this.riskState.stage.math.nominal;
        }
        //это нормально:
        //console.error( 'Server.get riskNominal(): seems like not even a risk state.' );
        return undefined;
    }
    /**
        * @returns {[String]} Массив возможных мастей карт в риске.
        * @memberOf Server
        */
    get riskSuitNames()
    {
        return this.loginData.spec.risks[ 0 ].specification.suitNames;
    }
    /**
        * @returns {String} Имя текущей карты в риске. Одно из "hearts" | "diamonds" | "spades" | "clubs".
        * @memberOf Server
        */
    get riskSuitName()
    {
        return this.riskSuitNames[ this.riskSuit ];
    }
    /**
        * @returns {Number} Мультипликатор текущего выигрыша в риске. Как я понимаю, либо 0, либо 2.
        */
    get riskWinMultiplier()
    {
        return this.riskState.stage.win_multiplier;
    }
    /**
        * @returns {Number} Какая карта была выбрана игроком. Константа из Server.RISK_CHOICE.
        * @memberOf Server
        */
    get riskChoice()
    {
        return resolveRiskChoice( this, this.riskState );
    }
    /**
        * @returns {Number} Сколько уже выиграно в риске.
        */
    get riskCurrentWin()
    {
        //сразу при входе в риск для отображения требуется узнать текущий выигрышь, хотя ещё ни одного финала риска не было, поэтому в таком случае нужно брать из основного спина:
        if ( this.riskState )
        {
            return stateWinInCoins( this.riskState )
        }
        //иногда требуется унать выигрышь в риске когда игра уже в состоянии FINAL:
        return stateWinInCoins( this.lastState )
    }
    /**
        * @returns {Number} Каким будет выигрыш игрока если он выиграет в текущем риске.
        */
    get riskFutureWin()
    {
        return this.riskCurrentWin * 2;
    }
    /**
        * @returns {[ { nominal : Number, suit : Number } ]} Последние 10 игр в риске.
        */
    get riskHistory()
    {
        return this.riskHistoryData;
    }
    /** Возвращает карту дилера если сейчас пятикарточный риск и игрок должен выбрать свою карту из четырёх предоставленных.*/
    get dealerCard()
    {
        return resolveDealerCard( this.lastState );
    }
    /** Шаг риска внутри сценария. Т.е. победа или ничья в риске увеличивают число в рамках сценария на 1. 0 - ни разу ещё не играли (может быть риск уже сейчас или сразу забрали выигрыш и сейчас игрок находится в FINAL (видит барабаны).*/
    get riskIteration()
    {
        return this.lastState.risk_iteration;
    }

    /**
        * @returns type of the current game.
        * @memberOf Server
        */
    get gameType()
    {
        return resolveGameType( this, this.lastState );
    }
    get type()
    {
        return this.lastState.stage.type_id
    }

    /**
        * @returns True если текущее состояние (Server.lastState) - это просто статическое (без показа выигрышных лини, анимаций, ...) отображение предыдущей стадии. Результат нажатия кнопки "COLLECT" (также известной как "take win").
        * @memberOf Server
        */
    get isFinal()
    {
        return this.gameType == this.GAME_TYPE.FINAL;
    }
    
    get riskState()
    {
        return this._riskState;
    }
    set riskState( to )
    {
        this._riskState = to;
        //чтобы однозначно ограничить переплетение логики соседних рисков:
        delete this.riskResult;
    }
    
    /** Last spin bet values. Lines would be for example [1,3,5,7,9].*/
    get betValue()
    {
        return {
            lines : this.lastState.line_count,
            multiplier : this.lastState.multiplier,
        };
    }
    betToValue( bet )
    {
        return {
            lines : this.loginData.spec.lines_array[ bet.lines ],
            multiplier : this.loginData.spec.bets_array[ bet.multiplier ],
        };
    }
    /** Last spin bet indices. Lines would be for example [0,1,2,3,4].*/
    get bet()
    {
        return {
            lines : this.loginData.spec.lines_array.indexOf( this.betValue.lines ),
            multiplier : this.loginData.spec.bets_array.indexOf( this.betValue.multiplier ),
        };
    }
    /** @param bet indices */
    price( bet )
    {
        bet = bet || this.bet;
        return this.loginData.spec.lines_array[ bet.lines ] * this.loginData.spec.bets_array[ bet.multiplier ];
    }
    cannotPay( bet )
    {
        return this.price( bet ) > this.credits;
    }
    /** Transforms specified bet in such a way that it can be paid.*/
    shrink( bet )
    {
        const r = Object.assign( {}, bet );
        //first try to get as high amount of lines as possible:
        r.multiplier = 0;
        r.lines = Math.min( bet.lines, this.loginData.spec.lines_array.length - 1 )
        while ( this.cannotPay( r ) )
        {
            if ( r.lines > 0 )
            {
                -- r.lines;
                continue;
            }
            break;
        }
        //then shrink multiplier starting from the specified amount:
        r.multiplier = Math.min( bet.multiplier, this.loginData.spec.bets_array.length - 1 )
        while ( this.cannotPay( r ) )
        {
            if ( r.multiplier > 0 )
            {
                -- r.multiplier;
                continue;
            }
            break;
        }
        return r;
    }
    
    get restore()
    {
        return this.stateOrder == 1;
    }
}

function server_login(
    server,
    username,
    password,
    onLogin,
    onFail,
    onFatal,
    options
)
{
    server.credential = { identity_type_id : SERVER_IDENTITY_TYPE.WEB, login : username };

    //перезаписываем какие-либо предыдущие печеньки так как при логине с инициативы клиента (а не лобби) session_id должен указываться пустым:
    cookies.set( "session_id", "", "server login" );
    cookies.set( "refresh_token", "", "server login" );
    //нет смысла беспокоиться о других потенциальных читателях печенек, так как они всё-равно могут прочитать их между этой попыткой записи оных и их фактической записью, что приведёт к наличию двух разных идентификаторов сессий (если они решал что её пора обновить в этот момент), поэтому разрыв соединения в таком случае всё-равно неизбежен:
    /*//flush:
    while ( Cookies.get( "session_id" ) !== "" )
    {
    }*/

    request(
        server,
        OPERATION_ID.SESSION_START_LOGIN,
        function(data) {
            cookies.set( "session_id", data.session_id, "session start" );
            cookies.set( "refresh_token", data.refresh_token, "session start" );

            requestLoginData(
                server,
                onLogin,
                onFail,
                onFatal,
                options
            );
        },
        {
            login : username,
            password : password,
            create : true,
            debug_project_name : ( options.tableMode ? 'SRS' : undefined )
        },
        undefined,
        onFail,
        onFatal
    );

    init( server );
}

/**
    * Keeps track of ongoing requests to determine if it needs to BeginScenario to make spin on server or WaySelect to switch to next stage (again, to actually get to [next] spin).
    * @param server
    * @param onResult
    * @param {onFail} onFail function( error : String )
    * @param {onFatal} onFatal
    */
function resolveNextStage(
    server,
    onResult,
    onFail,
    onFatal,
    lines,
    betPerLine
)
{
    var nextStageType = null;
    if (server.lastState.stage.type_id !== SERVER_STAGE_TYPE.FINAL_STAGE) {
        //looking for freegame or just final stage:
        for ( var nextStageIndex in server.lastState.way_map )
        {
            var nextStage = server.lastState.way_map[ nextStageIndex ];
            if ( nextStage === SERVER_STAGE_TYPE.FREEGAME || nextStage === SERVER_STAGE_TYPE.FINAL_STAGE )
            {
                nextStageType = nextStage;
                break;
            }
        }
        //if not found, then next scenes are risks or something like that ...
    }

    //no more scenes available in this scenario:
    if (nextStageType === null) {
        initiate_spin(
            server,
            lines,
            betPerLine,
            onResult,
            onFail,
            onFatal
        );
    }
    //just go to the next available stage whatever:
    else {
        goNextStage(
            server,
            nextStageType,
            function(state) {
                //since we're spinning, we don't need to see the resulting reels another time (because client have seen it within spin itself, he would need it if closed the game at the moment of reels spinning), so skip it and go directly to new scenario:
                if (state.stage.type_id === SERVER_STAGE_TYPE.FINAL_STAGE) {
                    initiate_spin(
                        server,
                        lines,
                        betPerLine,
                        onResult,
                        onFail,
                        onFatal
                    );
                }
                //otherwise it's some consecutive spin (as I understand, freespin after regular spin or previous freespin):
                else {
                    onResult( state );
                }
            },
            onFail,
            onFatal
        );
    }
}

function requestStateOnly(
    server,
    onSuccess,
    onFail,
    onFatal
)
{
    request(
        server,
        [
            OPERATION_ID.STATE_GET,
            OPERATION_ID.BALANCE_GET,
            OPERATION_ID.PROGRESSIVE_JACKPOT_GET
        ],
        [
            state => server.lastState = state,
            balance => server.balance = balance
        ],
        undefined,
        () => handlePostponed( server, onSuccess, onFail, onFatal ),
        onFail,
        onFatal
    )
}

/** Для реализации получения отложенного сценария на случай, если игра функционирует в режиме "СРС" (где random-seed основывается на букмекерских данных).
Обязательно должна присутствовать операция STATE_GET (помимо SCENARIO_GAME_BEGIN/WAY_SELECT).
*/
function handlePostponed(
    server,
    onSuccess,
    onFail,
    onFatal
)
{
    //СРС данные в играх с таким функционалом готовы на сервере только через указанное им время:
    if (
        server.lastState.hasOwnProperty( "math_info" )
        &&
        server.lastState.math_info.hasOwnProperty( "seconds_left" )
        &&
        server.lastState.math_info.seconds_left > 0
    )
    {
        console.log( '⚡⚡⚡ State retrieval postponed, will be ready in ' + server.lastState.math_info.seconds_left + ' seconds ...' );
        
        setTimeout(
            () => requestStateOnly( server, onSuccess, onFail, onFatal ),
            server.lastState.math_info.seconds_left * 1000
        );
    }
    else
    {
        //console.log( '⚡⚡⚡ No need to pospone state retrieval.' );
        onSuccess();
    }
}

function requestPostponedScenario(
    server,
    operationId,
    onResult,
    params,
    onSuccess,
    onFail,
    onFatal
)
{
    request(
        server,
        operationId,
        onResult,
        params,
        () => handlePostponed( server, onSuccess, onFail, onFatal ),
        onFail,
        onFatal
    )
}

function initiate_spin(
    server,
    lines,
    multiplier,
    onSpin,
    onFail,
    onFatal,
    skipToRisk
)
{
    if (lines === undefined || multiplier === undefined) {
        throw Error( 'wrong lines/multiplier' );
    }
    
    //чтобы при переключении сценарий игра не исползовала предыдущий:
    server.scenarioData = null;

    //initializing result data which will be eventually filled during requests:
    server.spinData = {
        settings : "not_set",
        credits : "not_set",
        state : "not_set"
    };
    
    var scenarioParams = {
        line_id : lines,
        bet_per_line : multiplier
    };
    if ( skipToRisk === true )
    {
        scenarioParams.skip_to_risk_stage = true;
    }
    if ( server.totalizator )
    {
        scenarioParams.delay_mode = true
    }

    requestPostponedScenario(
        server,
        [
            OPERATION_ID.SCENARIO_GAME_BEGIN,
            OPERATION_ID.BALANCE_GET,
            OPERATION_ID.STATE_GET,
            OPERATION_ID.PROGRESSIVE_JACKPOT_GET
        ],
        [
            undefined,
            function(getBalance) {
                server.balance = getBalance;
                server.spinData.balance = getBalance;
            },
            function(getState) {
                server.lastState = getState;
                server.spinData.state = getState;
            }
        ],
        [
            scenarioParams
        ],
        function()
        {
            //все остальные сообщения теперь с актуальной ставкой терминала:
            server.virginSession = false;
            
            //temporare patch to make roulette/jackpot being transparent for previous game flow consisting of just barrel spinning:
            switch ( server.lastState.stage.type_id )
            {
                case SERVER_STAGE_TYPE.PRECURSOR:
                case SERVER_STAGE_TYPE.JACKPOT:
                    server.pendingSpinHandler = onSpin;
                    break;
                    
                default:
                    onSpin( server.lastState );
                    break;
            }
        },
        onFail,
        onFatal
    );
}

/**
    *
    * @param server
    * @param stageType
    * @param onResult
    * @param {onFail} onFail function( error : String )
    * @param {onFatal} onFatal
    */
function goNextStage(
    server,
    stageType,
    onResult,
    onFail,
    onFatal
)
{
    server.nextStageData = {
        state : "not_set"
    };

    request(
        server,
        [
            OPERATION_ID.WAY_SELECT,
            OPERATION_ID.STATE_GET,
            OPERATION_ID.BALANCE_GET,
            OPERATION_ID.PROGRESSIVE_JACKPOT_GET
        ],
        [
            undefined,
            function(getState) {
                server.lastState = getState;
                server.nextStageData.state = getState;
            },
            function( balance )
            {
                server.balance = balance;
            }
        ],
        [
            {
                type_id : stageType
            }
        ],
        function() {
            if ( onResult )
            {
                onResult( server.nextStageData.state );
            }
            
            //temporare patch to make roulette/jackpot being transparent for previous game flow consisting of just barrel spinning:
            if ( server.lastState.stage.type_id == SERVER_STAGE_TYPE.REGULAR && server.pendingSpinHandler )
            {
                var temp = server.pendingSpinHandler;
                server.pendingSpinHandler = undefined;
                temp( server.lastState );
            }
        },
        onFail,
        onFatal
    );
}

Server.prototype.goNextStage = function(
    stageType,
    onResult,
    onFail,
    onFatal
)
{
    goNextStage(
        this,
        stageType,
        onResult,
        onFail,
        onFatal
    );
}

export function proceedRisk(
    server,
    riskResultState,
    onResult,
    onFail,
    onFatal
)
{
    server.riskState = riskResultState;

    //здесь может быть не только победа, но и ничья (в случае с пятикарточным риском):
    var nextStage = availableOrFinal( SERVER_STAGE_TYPE.RISK_MAIN, riskResultState );
    if ( server.riskState.stage.win_multiplier == 1 )
    {
        server.riskResult = server.RISK_RESULT.DRAW;
    }
    else
    {
        if ( nextStage == SERVER_STAGE_TYPE.RISK_MAIN )
        {
            server.riskResult = server.RISK_RESULT.WIN;
        }
        else
        {
            if ( server.riskState.stage.win_multiplier > 0 )
            {
                server.riskResult = server.RISK_RESULT.WIN_AND_CAPPED;
            }
            else
            {
                server.riskResult = server.RISK_RESULT.LOSE;
            }
        }
    }
    
    //так как аватар "помогает" игре и сам переходит в FINAL, то в случае наличия джекпота нужно перейти на джекпот:
    if ( nextStage == SERVER_STAGE_TYPE.FINAL )
    {
        nextStage = availableOrFinal( SERVER_STAGE_TYPE.JACKPOT, riskResultState )
    }
    
    request(
        server,
        [
            OPERATION_ID.WAY_SELECT,
            OPERATION_ID.STATE_GET,
            OPERATION_ID.RISK_HISTORY_GET,
            OPERATION_ID.BALANCE_GET
        ],
        [
            undefined,
            function( state )
            {
                server.lastState = state;
            },
            function( riskHistoryData )
            {
                server.riskHistoryData = riskHistoryData;
            },
            function( balance )
            {
                server.balance = balance;
            }
        ],
        [
            {
                type_id : nextStage
            },
            undefined,
            {
                risk_id : riskResultState.stage.risk_id
            }
        ],
        function()
        {
            var processed = undefined;

            switch ( riskResultState.stage.risk_id )
            {
                //подготавливаем данные для более убодного использования в игре:
                case RISK_TYPE.FIVE_CARDS:
                    processed = processRisk(
                        server,
                        riskResultState
                    );
                    break;
            }

            onResult(
                processed,
                resolveDealerCard( server.lastState )
            );
        },
        onFail,
        onFatal
    );
}

function handleMonitoringData(
    server,
    watchRecords
)
{
    server.monitorData = watchRecords;

    console.log( "Received " + watchRecords.records.length + " records:" );
    for ( var recordKey in watchRecords.records )
    {
        var record = watchRecords.records[ recordKey ];
        console.log( "    " + server.stageTypeName( record.operations[ OPERATION_ID.STATE_GET ].stage.type_id ) + " | #" + record.index );
    }
    console.log( "-----------------" );

    //способ приведения течения времени клиента параллельно серверному (синхронизация):
    server.monitorDelta = watchRecords.timestamp_begin - ( new Date ).getTime() / 1000.0;
    server.monitorServerEnd = watchRecords.timestamp_end;

    server.requestingMonitoringData = false;
}

/** Получение от сервера необходимых данных для запуска режима мониторинга.*/
function initMonitorState(
    server,
    onResult,
    onFail,
    onFatal
)
{
    server.requestingMonitoringData = true;

    request(
        server,
        [
            OPERATION_ID.SPECIFICATION_GET,
            OPERATION_ID.WATCH_RECORDS_GET
        ],
        [
            function( getSpec )
            {
                server.loginData.spec = getSpec;
            },
            function( watchRecords )
            {
                handleMonitoringData(
                    server,
                    watchRecords
                );
            }
        ],
        [
            undefined,
            {
                credential : server.monitor
            }
        ],
        function()
        {
            //игра не может отобразить даже начальный экран без начальных данных игрока, поэтому мы расчитываем на то что они будут присутствовать уже на этом этапе (у игрока, которого мониторим, должно быть хотя бы одно состояние):
            if ( ! ( server.monitorData.records instanceof Array ) )
            {
                onFatal( "Wrong server records initial data" );
                return;
            }
            if ( server.monitorData.records.length < 1 )
            {
                onFatal( "Not enough records initial data" );
                return;
            }
            applyMonitoringState(
                server,
                server.monitorData.records[ 0 ]
            );

            onResult();
        },
        onFail,
        onFatal
    )
}

function requestMonitoringData(
    server,
    onFail,
    onFatal
)
{
    server.requestingMonitoringData = true;

    request(
        server,
        OPERATION_ID.WATCH_RECORDS_GET,
        function( watchRecords )
        {
            handleMonitoringData(
                server,
                watchRecords
            );
        },
        {
            credential : server.monitor,
            last_state_index : server.monitorIndex
        },
        undefined,
        onFail,
        onFatal
    )
}

/**
    * Начальные данные для определения состояния игры и игрока, получаемые после логина. После этого достаточно информации чтобы spin()/freespin()/risk...
    */
export function requestLoginData(
    server,
    onResult,
    onFail,
    onFatal,
    options
)
{
    function requestData()
    {
        const operations = []
        const handlers = []
        const params = []
        
        const add = ( op, handler, param ) => {
            operations.push( op )
            handlers.push( handler )
            params.push( param )
        }
        
        if ( options.tableMode )
        {
            add(
                OPERATION_ID.WIN_TABLE_GET,
                winTable => {
                    server.winTable = winTable;
                    console.log( 'Received specification win table: ' + JSON.stringify( winTable ) );
                }
            )
            //чтобы сервер сам и сразу (без обратных запросов) проскочил до состояния риска независимо от того что сейчас (конец вращения или бонусы):
            add( OPERATION_ID.SCENARIO_SKIP_TO_RISK )
        }
        
        add(
            OPERATION_ID.SPECIFICATION_GET,
            spec => server.loginData.spec = spec
        )
        add(
            OPERATION_ID.USER_SETTINGS_GET,
            userSettings => server.loginData.settings = userSettings
        )
        add(
            OPERATION_ID.BALANCE_GET,
            balance => { server.balance = balance; server.loginData.balance = balance }
        )
        add(
            OPERATION_ID.PROGRESSIVE_JACKPOT_GET
        )
        add(
            OPERATION_ID.STATE_GET,
            state => { server.lastState = state; server.loginData.state = state }
        )
        add(
            OPERATION_ID.RISK_HISTORY_GET,
            riskHistoryData => server.riskHistoryData = riskHistoryData,
            {
                risk_id : ( options.riskId === undefined ? 1 : options.riskId )
            }
        )
        add(
            OPERATION_ID.CLIENT_DATA_SCENARIO_GET,
            scenarioData => server.scenarioData = scenarioData
        )
        
        if ( options.need_app_data )
        {
            add(
                OPERATION_ID.CLIENT_DATA_APP_GET,
                app_data => server.app_data = app_data
            )
        }
        
        requestPostponedScenario(
            server,
            operations,
            handlers,
            params,
            function()
            {
                //для терминала сбрасывать ставку в минимальную при первом подключении (в рамках сессии) и НЕ при восстановлении (FINAL):
                if (
                    server.virginSession &&
                    server.credential.identity_type_id == 1 &&
                    server.gameType == server.GAME_TYPE.FINAL
                )
                {
                    server.loginData.state.line_count = ( server.loginData.spec.lines_array && server.loginData.spec.lines_array[ 0 ] ) ? server.loginData.spec.lines_array[ 0 ] : 1;
                    server.loginData.state.multiplier = ( server.loginData.spec.bets_array && server.loginData.spec.bets_array[ 0 ] ) ? server.loginData.spec.bets_array[ 0 ] : 1;
                }
                
                verifyBonusData( server );

                //из-за проскакивания финальной стадии риска при игре в риск может не дойти запрос проскока после переключения на промежуточную стадию, поэтому здесь нужно снова её проскочить:
                if ( isRiskResult( server.lastState ) )
                {
                    console.log( '⚡⚡⚡ It\'s currently risk result state but game is unable to handle such state, so skipping it ...' );
                    
                    proceedRisk(
                        server,
                        server.lastState,
                        function()
                        {
                            onResult( server.loginData );
                        },
                        onFail,
                        onFatal
                    );
                }
                else
                {
                    //остальная часть игры реализована на стримах, которые из-за отложенных сценариев ещё не успели подцепить последнее состояние сервера (предыдущее могло быть, но быть пустым) - просто сбрасываем стэк чтобы стримы подцепили последнее:
                    setTimeout( () => onResult( server.loginData ), 1 )
                }
            },
            onFail,
            onFatal
        );
    }

    //создаём запрошенное клиентом состояние на сервере:
    if ( NODE_ENV === 'development' && server.spinCase !== undefined && ! server.scenarioForced )
    {
        //при восстановлении состояния pending сообщение на сервер перестаёт быть актуальном потому что, как мне кажется, запрос конкретного сценария убивает step_id:
        server.scenarioForced = true;
        
        console.log( "Forcing scenario " + server.spinCase.scenario + ", stage " + server.spinCase.stage + ", lines " + server.spinCase.lines + " ..." );

        request(
            server,
            OPERATION_ID.SCENARIO_GAME_BEGIN,
            undefined,
            {
                line_id : server.spinCase.lines,
                bet_per_line : server.spinCase.multiplier,
                debug_scenario_index : server.spinCase.scenario,
                //не знаю почему нельзя больше указывать сценарий если есть джекпот:
                debug_game_stage_index : ( server.spinCase.jackpot === undefined ? ( server.spinCase.stage || 0 ) : null ),
                debug_jackpot_win_coef : server.spinCase.jackpot,
                //если текущий сценарий не завершен тогда завершает его
                debug_finish_it : 1,
                delay_mode : server.totalizator
            },
            requestData,
            onFail,
            onFatal
        );
    }
    else
    {
        requestData();
    }
}

/** Сбросить callstack.*/
function postpone( what, param )
{
    setTimeout(
        function()
        {
            what( param );
        },
        1
    );
}

/** Притвориться будто сервер ответил на сетевое сообщение (а на самом деле это заготовленный стейт).*/
function monitorPretend( server, onResult )
{
    postpone(
        function()
        {
            applyMonitoringState(
                server,
                server.monitorNextRecord
            );

            //подготовить карты риска для обойдённого состояния RISK_RESULT:
            if ( server.riskResultState )
            {
                console.log( '  risk state IS present, responding with it to monitor.' );
                onResult(
                    processRisk( server, server.riskResultState ),
                    resolveDealerCard( server.lastState )
                );
            }
            else
            {
                onResult( server.lastState );
            }
        }
    );
}

/** Применить указанный state мониторинга как если игрок перешёл на него самостоятельно (как в обычном режиме - НЕ в мониторинге).
    * Спецификация network_api: Server принимает такое состояние, будто оно было получено в результате настоящего общения с сервером, а не лишь в результате мониторинга, так что все остальные функции работают также*/
function applyMonitoringState(
    server,
    record
)
{
    var o = record.operations;

    server.balance = server.loginData.balance = o[ OPERATION_ID.BALANCE_GET ];
    server.loginData.state = server.lastState = o[ OPERATION_ID.STATE_GET ];
    server.loginData.settings = o[ OPERATION_ID.USER_SETTINGS_GET ];
    server.riskHistoryData = o[ OPERATION_ID.RISK_HISTORY_GET ];
    server.scenarioData = o[ OPERATION_ID.CLIENT_DATA_SCENARIO_GET ];

    if ( server.lastState.stage.type_id == SERVER_STAGE_TYPE.FINISH )
    {
        console.log( 'Replicated FINISH state to ' + JSON.stringify( server.lastState ) + ' from ' + JSON.stringify( o ) );
    }
}

function resolveRiskChoice( server, state )
{
    if ( state )
    {
        switch ( state.stage.type_id )
        {
            case SERVER_STAGE_TYPE.RISK_RESULT_RED:
                return server.RISK_CHOICE.RED;
            case SERVER_STAGE_TYPE.RISK_RESULT_BLACK:
                return server.RISK_CHOICE.BLACK;
        }
    }
    return SERVER_STAGE_TYPE.UNDEFINED;
}

function resolveGameType( server, state )
{
    //TODO: other types not implemented on server yet so we don't know how to determine between them ...
    switch ( parseInt( state.stage.type_id ) )
    {
        case SERVER_STAGE_TYPE.REGULAR:
            return server.GAME_TYPE.REGULAR;

        case SERVER_STAGE_TYPE.FINAL:
            return server.GAME_TYPE.FINAL;

        case SERVER_STAGE_TYPE.FREEGAME:
            return server.GAME_TYPE.FREEGAME;

        case SERVER_STAGE_TYPE.BONUS_1:
            return server.GAME_TYPE.BONUS_1;

        case SERVER_STAGE_TYPE.BONUS_2:
            return server.GAME_TYPE.BONUS_2;

        case SERVER_STAGE_TYPE.BONUS_3:
            return server.GAME_TYPE.BONUS_3;

        case SERVER_STAGE_TYPE.FINISH:
            return server.GAME_TYPE.FINISH;
        
        case SERVER_STAGE_TYPE.JACKPOT:
            return server.GAME_TYPE.JACKPOT;
        
        case SERVER_STAGE_TYPE.PRECURSOR:
            if ( state.way_map.find( function( avail ) { return avail == SERVER_STAGE_TYPE.PRECURSOR; } ) )
            {
                return server.GAME_TYPE.PRECURSOR_STARTING;
            }
            return server.GAME_TYPE.PRECURSOR;

        case SERVER_STAGE_TYPE.RISK_MAIN:
            return server.GAME_TYPE.RISK;
    }
    
    console.error( 'Server.resolveGameType: gameType =', state.stage.type_id, 'is undefined.' )
    
    return server.GAME_TYPE.UNDEFINED_GAME_TYPE;
}

export function isRiskResult( state )
{
    if ( state && state.stage )
    {
        switch ( state.stage.type_id )
        {
            case SERVER_STAGE_TYPE.RISK_RESULT_RED:
            case SERVER_STAGE_TYPE.RISK_RESULT_BLACK:
            case SERVER_STAGE_TYPE.RISK_RESULT:
                return true;
        }
    }

    return false;
}

export function resolveCredits( balance )
{
    return parseInt( balance.gameable );
}

/** Берёт из указанного состояния ответа сервера карту дилера, если есть.
    * @return { rank : Int, suit : Int } */
export function resolveDealerCard( state )
{
    //using if() instead of try/catch to avoid debugger stops:
    if ( state && state.stage && state.stage.math )
    {
        return state.stage.math.dealerCard;
    }

    return undefined;
}

/** Возвращает обработанное состояние риска для более удобного использования в игре.*/
export function processRisk(
    server,
    riskState
)
{
    if ( ! riskState ) return;
    const choice = server.scenarioData ? server.scenarioData.choice : undefined;
    
    var processed = {
        dealer : resolveDealerCard( riskState ),
        cards : [],
        choice,
        //true если ничья:
        forward : riskState.stage.win_multiplier == 1
    };

    var playerCards = riskState.stage.math.playerCards;
    if ( playerCards )
    {
        for ( var i in playerCards.rank )
        {
            if ( playerCards.rank.hasOwnProperty( i ) !== true )
            {
                continue;
            }

            processed.cards.push(
                {
                    rank : playerCards.rank[ i ],
                    suit : playerCards.suit[ i ]
                }
            );
        }
    }
    
    if ( choice !== undefined )
    {
        const swapChoice = choice - 1;
        var swap = processed.cards[ swapChoice ];
        processed.cards[ swapChoice ] = processed.cards[ 0 ];
        processed.cards[ 0 ] = swap;
    }

    return processed;
}

function verifyBonusData( server )
{
    var mathN = 'undefined';
    let type = server.type
    if ( type == TYPE.FINISH ) type = server.math.featureType
    switch ( type )
    {
        case TYPE.BONUS_1:
            mathN = '1';
            break;
        case TYPE.BONUS_2:
            mathN = '2';
            break;
        case TYPE.BONUS_3:
            mathN = '3';
            break;
    }
    
    const wins = server.math[ "bonus" + mathN + "Wins" ]
    //не бонус:
    if ( ! wins ) return
    let step = wins.length

    //используется когда обнаружена любая ошибка в данных - они инициализируется чем-то случайным новым:
    function init( setting, reason )
    {
        console.error( 'Corrupted data encountered: ' + reason + '! Performing the recovery for ' + step + ' steps ...' );

        server.scenarioData = [];
        if ( setting.flat ) step = 1

        let candidates = undefined;
        if ( setting.exclusive )
        {
            candidates = []
            for ( var ci = setting.from; ci <= setting.to; ++ ci )
            {
                candidates.push( ci )
            }
        }

        //choice for every passed step:
        for ( var si = 0; si < step; ++ si )
        {
            //random() использовать нельзя иначе мониторинг работать не будет ...
            var choice;
            if ( candidates )
            {
                if ( candidates.length < 1 )
                {
                    console.error( '    no candidates remaining to fill data with' );
                    choice = setting.from;
                }
                else
                {
                    choice = candidates[ 0 ];
                    candidates.shift();
                }
            }
            else
            {
                choice = 0
            }

            server.scenarioData.push( choice );
        }
    }

    var settingFound = false;

    for ( const setting of server.bonusSettings )
    {
        if (
            server.gameType != setting.gameType
            &&
            type != setting.type
        )
        {
            continue;
        }

        settingFound = true;
        
        if ( setting.custom ) continue

        if ( ! server.scenarioData )
        {
            init( setting, 'no data at all' );
            break;
        }
        
        if ( setting.flat )
        {
            if ( server.scenarioData.length != 1 )
            {
                init( setting, "flat bonus has only one step with math having an array of wins" )
                break
            }
        }
        else
        {
            if ( server.scenarioData.length != step )
            {
                init( setting, 'different steps amount' );
                break;
            }
        }

        //to check exclusiveness:
        var choices = [];

        for ( var i = 0; i < server.scenarioData.length; ++ i )
        {
            var choice = server.scenarioData[ i ];
            if ( setting.choices )
            {
                if ( ! setting.choices[ i ] )
                {
                    init( setting, "no corresponding step" )
                    break
                }
                
                if ( choice < 0 || choice >= setting.choices[ i ] )
                {
                    init( setting, "choice out of bounds" + setting.choices[ i ] )
                    break
                }
            }
            else
            {
                if ( choice < setting.from )
                {
                    init( setting, 'less than minimum choice' );
                    break
                }
                if ( choice > setting.to )
                {
                    init( setting, 'more than maximum choice' );
                    break
                }
                if ( setting.exclusive )
                {
                    if ( _.includes( choices, choice ) )
                    {
                        init( setting, 'repeated choice when exclusive' );
                        break
                    }

                    choices.push( choice );
                }
            }
        }

        break;
    }

    if ( settingFound )
    {
        console.log( 'Bonus data "' + JSON.stringify( server.scenarioData ) + '" successfully verified.' );
    }
    else
    {
        console.error( 'Bonus setting was NOT found. Cannot verify it.' );
    }
}

/** Choose specified available state if such is actually available or result to FINAL one.*/
export function availableOrFinal(
    available,
    state
)
{
    var isAvailable = state.way_map.find( function( availableChoice )
    {
        return available == availableChoice;
    } );
    if ( isAvailable === undefined )
    {
        return SERVER_STAGE_TYPE.FINAL;
    }
    return available;
}

export function canGo( stage, state )
{
    if ( state.state ) state = state.state;
    return state.way_map.find( availableChoice => stage == availableChoice ) !== undefined;
}

export function canOnlyGo( stage, state )
{
    if ( state.state ) state = state.state;
    return state.way_map.length == 1 && state.way_map[ 0 ] == stage;
}

export function cannotGo( stage, state )
{
    if ( state.state ) state = state.state;
    return ! _.includes( state.way_map, stage );
}

export function stateWinInCoins(
    state
)
{
    return parseInt( state.open_win )
}




// WEBPACK FOOTER //
// ./src/library/network/network_api.es6